import { render, staticRenderFns } from "./SkippyAds.vue?vue&type=template&id=bb7bf5f6&"
import script from "./SkippyAds.vue?vue&type=script&lang=js&"
export * from "./SkippyAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports